module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/minimal_1-41093a712091449b39f22b33ca3a42bc.png";